import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, LazyAction, type LazyComponent } from 'owa-bundling';
import store from './store/store';
import type { PrimaryMailboxRootContextMenuItemsProps } from './utils/getPrimaryMailboxRootContextMenuItems';
import type { MailFolderContextMenuProps } from './components/MailFolderContextMenu';
import type { SharedFolderTreeProps } from './components/SharedFolderTree';
import type { SharedFolderTreeParentContainerProps } from './components/SharedFolderTreeParentContainer';
import type { ArchiveMailFolderTreeContainerProps } from './components/ArchiveMailFolderTreeContainer';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailFolderTreeContainerView" */ './lazyIndex'),
    { name: 'MailFolderTreeContainerView' }
);

export const ArchiveMailFolderTreeContainer: LazyComponent<
    ArchiveMailFolderTreeContainerProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.ArchiveMailFolderTreeContainer);
export const SharedFolderTreeParentContainer: LazyComponent<
    SharedFolderTreeParentContainerProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.SharedFolderTreeParentContainer);
export const SharedFolderTree: LazyComponent<SharedFolderTreeProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.SharedFolderTree);
export const MailFolderContextMenu: LazyComponent<MailFolderContextMenuProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailFolderContextMenu);

export const LazyPrimaryMailboxRootContextMenuItems: LazyComponent<
    PrimaryMailboxRootContextMenuItemsProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.PrimaryMailboxRootContextMenuItems);

export const LazyMailFolderDialogsWrapper: LazyComponent<unknown, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailFolderDialogsWrapper);

export const lazySetShouldShowMoveToFolderDialog: LazyAction<
    typeof lazyIndex.setShouldShowMoveToFolderDialogMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setShouldShowMoveToFolderDialogMutator);

export const LazyMoveToFolderDialog: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.MoveToFolderDialog,
    undefined,
    undefined,
    { onlyImportIf: () => store().shouldShow }
);
